import React, { FC } from "react";
import { Field, FieldRenderProps } from "react-final-form";
import SelectionButton from "../controls/SelectionButton";
import SubmitError from "./SubmitError";
import { t } from "../../i18n";

interface StyledButtonsArrayProps {
    i18nScope: string;
    fieldName: string;
    options: { value: string, svgSymbolId?: SvgSymbolId }[];
}

const StyledButtonsArray:FC<StyledButtonsArrayProps> = ({ i18nScope, fieldName, options }) => {
  return (
    <Field name={fieldName} render={(renderProps: FieldRenderProps<number | string>): React.ReactNode => {
      const { input, meta } = renderProps;
      return (
        <>
          <p className="mt-10 mb-5 font-semibold">{t(`${i18nScope}.title`)}</p>
          <div>
            {options.map(({ value, svgSymbolId }) => (
              <SelectionButton
                className="pl-5 pr-6"
                i18nKey={`${i18nScope}.${value}`}
                input={input}
                key={value}
                symbolId={svgSymbolId}
                value={value}
              />
            ))}
          </div>
          <SubmitError errors={meta.submitError}/>
        </>
      );
    }}/>
  )
};

export default StyledButtonsArray;
